import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TabBilleteros from './TabBilleteros'
import TabDispenzadorBilletes from './TabDispenzadorBilletes'
import TabDispenzadorMonedas from './TabDispenzadorMonedas'
import TabRecicladorMonedas from './TabRecicladorMonedas'
import TabRecicladorBilletes from './TabRecicladorBilletes'
import TabImpresoras from './TabImpresoras'
import TabCerraduras from './TabCerraduras'
import TabSas from './TabSas'
import TabManager from './TabManager'
import { Alert, AlertTitle, Chip, Collapse, Divider, Paper, Snackbar, Stack, TableBody, Typography } from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import RecyclingIcon from '@mui/icons-material/Recycling'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import PrintIcon from '@mui/icons-material/Print'
import LockIcon from '@mui/icons-material/Lock'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DevicesOtherIcon from '@mui/icons-material/DevicesOther'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet'
import CasinoIcon from '@mui/icons-material/Casino'

// Iconos por tipo de dispositivo (usado en la navegacion lateral y el resumen)
const ICONOS_TIPO = {
    billeteros: AttachMoneyIcon,
    dispenzadores_billetes: LocalAtmIcon,
    dispenzadores_monedas: MonetizationOnIcon,
    recicladores_monedas: RecyclingIcon,
    recicladores_billetes: CurrencyExchangeIcon,
    impresoras: PrintIcon,
    cerraduras: LockIcon,
    sas: CasinoIcon,
    manager: SettingsEthernetIcon
}

// Etiqueta singular por tipo para la tabla resumen
const NOMBRE_SINGULAR = {
    billeteros: 'Billetero',
    dispenzadores_billetes: 'Dispensador Billetes',
    dispenzadores_monedas: 'Dispensador Monedas',
    recicladores_monedas: 'Reciclador Monedas',
    recicladores_billetes: 'Reciclador Billetes',
    impresoras: 'Impresora',
    cerraduras: 'Cerradura',
    sas: 'Dispositivo SAS',
    manager: 'Manager'
}

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class CajerosDispositivosComplementosPage extends Component {

    constructor(props) {
        super(props)

        var idCajero = props.location.state.id_cajero

        this.state ={
            idCajero: idCajero,
            cajero : null,
            cajeros: [],
            currentTab: null,
            currentTipoId: null,
            tipoDispositivos: [
                {id: "manager", nombre: "Manager"},
                {id: "billeteros", nombre: "Billeteros"},
                {id: "dispenzadores_billetes", nombre: "Dispensadores Billetes"},
                {id: "dispenzadores_monedas", nombre: "Dispensadores Monedas"},
                {id: "recicladores_monedas", nombre: "Recicladores Monedas"},
                {id: "recicladores_billetes", nombre: "Recicladores Billetes"},
                {id: "impresoras", nombre: "Impresoras"},
                {id: "cerraduras", nombre: "Cerraduras"},
                {id: "sas", nombre: "Dispositivo SAS"}
            ],
            dispositivosCajero: {},
            mostrarAlerta: false,
            mensajeAlerta: '',
            severidadAlerta: '',
        }

		this.cmbCajerosClonar = React.createRef()
        this.seleccionarTipo = this.seleccionarTipo.bind(this)
        this.guardarDispositivos = this.guardarDispositivos.bind(this)
        
    }

    showAlert = (mensaje, severidad) => {
        this.setState({
            mostrarAlerta: true,
            mensajeAlerta: mensaje,
            severidadAlerta: severidad,
        });
    }
    
    handleCloseAlert= (event, reason) => {
        if (reason === 'clickaway') {
          return; // Evitar que se cierre si el usuario hace clic fuera
        }
        this.setState({ mostrarAlerta: false })
    }

    seleccionarTipo(tipo) {

        var dispositivos = []
        var tab = this.state.currentTab


        if(this.state.dispositivosCajero != null && this.state.dispositivosCajero[tipo]) {
            dispositivos = this.state.dispositivosCajero[tipo]
        }

        switch(tipo) {
            case 'billeteros':
                tab = <TabBilleteros xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'dispenzadores_billetes':
                tab = <TabDispenzadorBilletes xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'dispenzadores_monedas':
                tab = <TabDispenzadorMonedas xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'recicladores_monedas':
                tab = <TabRecicladorMonedas xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'recicladores_billetes':
                tab = <TabRecicladorBilletes xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'impresoras':
                tab = <TabImpresoras xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'cerraduras':
                tab = <TabCerraduras xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'sas':
                tab = <TabSas xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            case 'manager':
                tab = <TabManager xs={8} tipoDispositivo={tipo} dispositivos={dispositivos} event={this.guardarDispositivos} />
                break
            default:
                break
        }

        this.setState({
            currentTab: tab,
            currentTipoId: tipo
        })

    }

    componentDidMount() {
        this.queryDispositivos()
        this.queryCajeros()
    }
    
    queryCajeros() {
    console.log('Consultando cajeros....')
     var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando cajeros")
        //console.log('Error respuesta consultando cajeros')

        this.showAlert('Error consultando cajeros', 'error')
        this.setState({
			cajeros: [],
			mensajeError: data.message
        })
      } else {
        //console.log('Cajeros consultados')
      	this.setState({
        	cajeros: data
        })
      }
    })
    
   }

    queryDispositivos() {
		this.setState({
			currentTab: null
		})

        var restArgs = {
          method: 'POST',
          headers: 'JSON',
          body: {
			  id_cajero: this.state.idCajero
			},
          url: process.env.REACT_APP_URL_BACKEND + '/cajeros/dispositivos'
        }
    
        RestTunel.makePetition(restArgs,(err, data) => {
          if(err) {
            //alert("Error consultando cajero")
            this.showAlert('Error consultando cajero', 'error')
            this.setState({
                dispositivosCajero: {}
            })
          } else {
            var dispositivosCajero = {}

            try {
                dispositivosCajero = JSON.parse(data.dispositivos)

                if(dispositivosCajero === null) {
                    dispositivosCajero = {}
                }
            } catch (error) {
                //console.log(error)
            }

            this.setState({
                cajero: data,
                dispositivosCajero: dispositivosCajero
            })
          }
        })
    
    }

    guardarDispositivos(tipo, dispositivos, confirmacionGuardado) {

        var dispositivosCajero = this.state.dispositivosCajero

        dispositivosCajero[tipo] = dispositivos

        var restArgs = {
            method: 'PATCH',
            headers: 'JSON',
            body: {
                id_cajero: this.state.idCajero,
                dispositivos: dispositivosCajero
            },
            url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/dispositivos'
          }
      
          RestTunel.makePetition(restArgs,(err, data) => {
            if(err) {
                //alert("Error actualizando dispositivos cajero")
                this.showAlert('Error actualizando dispositivos cajero', 'error')
            } else {
                confirmacionGuardado()
                //alert("Dispositivos actualizados") 
                this.showAlert('Dispositivos actualizados', 'success')
                this.queryDispositivos()
            }
          })
          
    }
    
    btnClonarClick = () => {
		//console.log('Clonar dispositivo....')

		var idCajeroOrigen = ''

		if(this.cmbCajerosClonar.current.value !== 0){
	      idCajeroOrigen = this.cmbCajerosClonar.current.value
	    } else {
			return
		}
	    
	    var restArgs = {
	      method: 'PATCH',
	      headers: 'JSON',
	      body: {
			  id_cajero_origen: idCajeroOrigen,
			  id_cajero_destino: this.state.idCajero,
			  
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/dispositivosclonar'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error clonando dispositivos")
            this.showAlert('Error clonando dispositivos', 'error')
	        //console.log('Error respuesta clonando dispositivos')
	      } else {
	        //console.log('Dispositivos clonados')
	        //alert("Dispositivos clonados")
            this.showAlert('Dispositivos clonados', 'success')
			this.queryDispositivos()
	      }
	    })
	}

    // Cuenta los dispositivos configurados de un tipo
    contarDispositivos(tipoId) {
        const disp = this.state.dispositivosCajero
        if(disp === null || disp[tipoId] === undefined) return 0
        // Manager: no es una lista de dispositivos sino una config de puertos; el
        // contador refleja cuantos puertos estan llenos (1 a 3), no la longitud.
        if(tipoId === 'manager') {
            const cfg = (Array.isArray(disp[tipoId]) && disp[tipoId].length > 0) ? disp[tipoId][0] : {}
            return ['puerto_esp']
                .filter(k => cfg[k] !== undefined && cfg[k] !== null && String(cfg[k]).trim() !== '').length
        }
        return disp[tipoId].length
    }

    // Renderiza un chip de estado (A = Activo, I = Inactivo)
    chipEstado(estado) {
        const activo = estado === 'A'
        return (
            <Chip
                size="small"
                label={activo ? 'Activo' : 'Inactivo'}
                color={activo ? 'success' : 'default'}
                variant={activo ? 'filled' : 'outlined'}
            />
        )
    }

    render() {
        var dispositivos = this.state.dispositivosCajero || {}

        // Filas del resumen: aplana todos los tipos en una sola lista
        var filasResumen = []
        this.state.tipoDispositivos.forEach((tipo) => {
            // 'manager' es config de puertos, no una lista de dispositivos: no va al resumen.
            if(tipo.id === 'manager') return
            const items = dispositivos[tipo.id] || []
            items.forEach((item) => {
                filasResumen.push({ tipoId: tipo.id, item: item })
            })
        })

        // Total para el chip del encabezado: dispositivos del resumen + los puertos
        // configurados del Manager (que no van al resumen pero sí cuentan).
        var totalDispositivos = filasResumen.length + this.contarDispositivos('manager')

        return(
            <Box>
                {/* Alerta unica a nivel de pagina */}
                <Snackbar
                    open={this.state.mostrarAlerta}
                    onClose={this.handleCloseAlert}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                    <Collapse in={this.state.mostrarAlerta}>
                        <Alert
                            severity={this.state.severidadAlerta || 'info'}
                            onClose={this.handleCloseAlert}
                            variant="filled"
                            sx={{ width: '100%' }}
                            >
                            <AlertTitle>
                                {(this.state.severidadAlerta || '').toUpperCase()}
                            </AlertTitle>
                            {this.state.mensajeAlerta}
                        </Alert>
                    </Collapse>
                </Snackbar>

                {/* Encabezado del cajero */}
                <Paper elevation={3} sx={{ marginBottom: 3, borderRadius: 2, overflow: 'hidden' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, p: 2.5 }}>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Box sx={{ bgcolor: 'primary.main', color: '#fff', width: 48, height: 48, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <PointOfSaleIcon />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                                    {this.state.cajero != null ? this.state.cajero.alias : '—'}
                                </Typography>
                                <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                                    <Chip size="small" label={'Cajero: ' + (this.state.cajero != null ? this.state.cajero.codigo : '—')} />
                                    <Chip size="small" color="primary" variant="outlined" icon={<DevicesOtherIcon />} label={totalDispositivos + ' dispositivos'} />
                                </Stack>
                            </Box>
                        </Stack>
                        <Link
                            to={{
                                pathname: '/dashboard/cajeros/editar',
                                state: {id_cajero: this.state.idCajero}
                            }}
                            style={{ textDecoration: 'none' }}>
                            <Button variant="outlined" color="primary" startIcon={<ArrowBackIcon />}>Volver</Button>
                        </Link>
                    </Box>
                </Paper>

                <Grid container spacing={3}>
                    {/* Navegacion lateral: tipos de dispositivo + clonar */}
                    <Grid item xs={12} md={3}>
                        <Card elevation={2} sx={{ borderRadius: 2, mb: 3 }}>
                            <CardContent>
                                <Typography variant="overline" color="text.secondary">Tipos de dispositivo</Typography>
                                <Stack spacing={1} sx={{ mt: 1 }}>
                                    {this.state.tipoDispositivos.map((tipo) => {
                                        const Icono = ICONOS_TIPO[tipo.id] || DevicesOtherIcon
                                        const activo = this.state.currentTipoId === tipo.id
                                        const cantidad = this.contarDispositivos(tipo.id)
                                        return (
                                            <Button
                                                key={tipo.id}
                                                fullWidth
                                                disableElevation
                                                variant={activo ? 'contained' : 'outlined'}
                                                color={activo ? 'primary' : 'inherit'}
                                                startIcon={<Icono />}
                                                onClick={() => this.seleccionarTipo(tipo.id)}
                                                sx={{ justifyContent: 'space-between', textTransform: 'none', py: 1, px: 1.5 }}
                                                >
                                                <Box component="span" sx={{ flexGrow: 1, textAlign: 'left' }}>{tipo.nombre}</Box>
                                                <Chip
                                                    size="small"
                                                    label={cantidad}
                                                    color={activo ? 'default' : 'primary'}
                                                    sx={{ height: 20, minWidth: 28 }}
                                                />
                                            </Button>
                                        )
                                    })}
                                </Stack>
                            </CardContent>
                        </Card>

                        {/* Resumen de dispositivos configurados */}
                        <Card elevation={2} sx={{ borderRadius: 2, mb: 3 }}>
                            <CardContent>
                                <Typography variant="overline" color="text.secondary">Resumen de dispositivos</Typography>
                                <Divider sx={{ mt: 1, mb: 1 }} />
                                <TableContainer>
                                    <Table stickyHeader class="table-data" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Dispositivo</TableCell>
                                                <TableCell>Tipo</TableCell>
                                                <TableCell>Estado</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filasResumen.length === 0
                                                ? (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center" sx={{ color: 'text.secondary', py: 4 }}>
                                                            No hay dispositivos configurados.
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                                : filasResumen.map((fila, idx) => {
                                                    const Icono = ICONOS_TIPO[fila.tipoId] || DevicesOtherIcon
                                                    return (
                                                        <TableRow key={fila.tipoId + '-' + idx} hover>
                                                            <TableCell>
                                                                <Stack direction="row" spacing={1} alignItems="center">
                                                                    <Icono fontSize="small" color="action" />
                                                                    <span>{NOMBRE_SINGULAR[fila.tipoId] || fila.tipoId}</span>
                                                                </Stack>
                                                            </TableCell>
                                                            <TableCell>{fila.item.tipo || fila.item.tipoDispenzador || fila.item.tipoReciclador || '—'}</TableCell>
                                                            <TableCell>{this.chipEstado(fila.item.estado)}</TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>

                        <Card elevation={2} sx={{ borderRadius: 2 }}>
                            <CardContent>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
                                    <ContentCopyIcon fontSize="small" color="action" />
                                    <FormLabel>Clonar configuración de:</FormLabel>
                                </Stack>
                                <form>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Cajero origen</InputLabel>
                                        <Select
                                            label="Cajero origen"
                                            inputRef={this.cmbCajerosClonar}
                                            defaultValue={0}>
                                            <MenuItem value={0}>-- Seleccione cajero --</MenuItem>
                                            {this.state.cajeros.map(cajero => (
                                                <MenuItem key={cajero.id} value={cajero.id}>{cajero.alias}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </form>
                            </CardContent>
                            <CardActions sx={{ px: 2, pb: 2 }}>
                                <Button variant="contained" fullWidth startIcon={<ContentCopyIcon />} onClick={this.btnClonarClick}>Clonar</Button>
                            </CardActions>
                        </Card>
                    </Grid>

                    {/* Panel principal: formulario del tipo seleccionado */}
                    <Grid item xs={12} md={9}>
                        {this.state.currentTab != null
                            ? this.state.currentTab
                            : (
                                <Card elevation={2} sx={{ borderRadius: 2 }}>
                                    <CardContent sx={{ py: 8, textAlign: 'center' }}>
                                        <DevicesOtherIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 1 }} />
                                        <Typography variant="h6" color="text.secondary">Seleccione un tipo de dispositivo</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Elija una opción del panel izquierdo para configurar sus dispositivos.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            )
                        }
                    </Grid>
                </Grid>

            </Box>
        )
    }

}

export default CajerosDispositivosComplementosPage